module.exports = __webpack_public_path__ + "static/media/13.f6ab19e4.jpg";